/* eslint-disable */
/* eslint-disable no-restricted-globals, no-undef */
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  Input,
  Textarea,
  Select,
  useToast,
  Switch,
  Checkbox,
  CheckboxGroup,
  Stack,
  Text,
  VStack,
  HStack,
  Heading,
  Card,
  CardBody,
  IconButton,
  Badge,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Spinner,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Icon,
  useColorModeValue
} from "@chakra-ui/react";
import { FaPlayCircle, FaFilePdf, FaBrain } from "react-icons/fa";
import React, { useState, useEffect } from "react";
import { DEPARTMENTS } from "../../constants/departments";
import { ArrowUpIcon, ArrowDownIcon, DeleteIcon, EditIcon, AddIcon } from "@chakra-ui/icons";
import axios from "axios";
import "./edit.css";
import AdminNavTop from "../AdminNavTop";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { patchProduct, getProduct } from "../../Redux/AdminReducer/action";
import { useModalToast } from "../../context/GlobalModalToast";

const EditPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const store = useSelector((store) => store.AdminReducer.data) || [];
  const { toast, confirm } = useModalToast();
  const navigate = useNavigate();

  const existedUser = Array.isArray(store) ? store.filter((el) => el && el._id == id) : [];

  let obj = {
    title: existedUser[0]?.title || "",
    description: existedUser[0]?.description || "",
    category: existedUser[0]?.category || "",
    teacher: existedUser[0]?.teacher || "",
    teacherId: existedUser[0]?.teacherId || "",
    isGlobal: existedUser[0]?.isGlobal !== undefined ? existedUser[0]?.isGlobal : true,
    targetSectors: existedUser[0]?.targetSectors || [],
    img: existedUser[0]?.img || existedUser[0]?.thumbnail || "",
    allowComments: existedUser[0]?.allowComments !== undefined ? existedUser[0]?.allowComments : true
  };

  const [detail, setDetail] = useState(obj);
  const [sections, setSections] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [customCategory, setCustomCategory] = useState("");
  const [teachers, setTeachers] = useState([]);

  // Section Modal State
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [editingIndex, setEditingIndex] = useState(-1); // -1 means adding new
  const [sectionForm, setSectionForm] = useState({
    title: "",
    type: "video",
    content: "",
    transcript: "",
    isVideoUpload: false});
  const [isUploading, setIsUploading] = useState(false);

  // Fetch course details, sections, categories, and teachers on mount
  useEffect(() => {
    const fetchCourseData = async () => {
      setIsLoading(true);
      try {
        const token = JSON.parse(localStorage.getItem("user"))?.token || "";
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/courses/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        setDetail({
          title: res.data.title || "",
          description: res.data.description || "",
          category: res.data.category || "",
          department: res.data.department || "",
          teacher: res.data.teacher || "",
          teacherId: res.data.teacherId || "",
          isGlobal: res.data.isGlobal !== undefined ? res.data.isGlobal : true,
          targetSectors: res.data.targetSectors || [],
          img: res.data.img || res.data.thumbnail || "",
          allowComments: res.data.allowComments !== undefined ? res.data.allowComments : true
        });
        setSections(res.data.sections || []);
      } catch (err) {
        console.error(err);
        toast({ title: "Failed to load course details", status: "error", duration: 3000 });
      } finally {
        setIsLoading(false);
      }
    };

    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/categories`);
        setCategories(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    const fetchTeachers = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("user"))?.token || "";
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/teachers`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setTeachers(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCourseData();
    fetchCategories();
    fetchTeachers();
  }, [id, toast]);

  const handleAddCustomCategory = async () => {
    if (!customCategory.trim()) {
      toast({ title: "Please enter category name", status: "warning", duration: 3000 });
      return;
    }
    try {
      const token = JSON.parse(localStorage.getItem("user"))?.token || "";
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/categories`, {
        name: customCategory.trim()
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast({ title: "Category added successfully", status: "success", duration: 3000 });
      setDetail(prev => ({ ...prev, category: res.data.name }));
      setCustomCategory("");
      setShowCustomInput(false);
      // fetchCategories();
    } catch (err) {
      toast({ title: err.response?.data?.message || "Failed to add category", status: "error", duration: 3000 });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetail((prev) => ({ ...prev, [name]: value }));
  };

  const handleSectionFormChange = (e) => {
    const { name, value } = e.target;
    setSectionForm((prev) => ({ ...prev, [name]: value }));
  };

  // Upload handler for replacement video/PDFs
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    setIsUploading(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" }});
      
      const fileName = file.name.toLowerCase();
      const isPdf = file.type === 'application/pdf' || fileName.endsWith('.pdf');
      const isVideo = file.type.startsWith('video/');

      setSectionForm((prev) => ({
        ...prev,
        content: res.data.url,
        transcript: res.data.transcript || prev.transcript || "",
        type: isPdf ? 'documentation' : (isVideo ? 'video' : prev.type),
        isVideoUpload: isVideo
      }));
      toast({ title: "File uploaded successfully!", status: "success", duration: 3000 });
    } catch (err) {
      console.error(err);
      toast({ title: "Upload failed. Please try again.", status: "error", duration: 3000 });
    } finally {
      setIsUploading(false);
    }
  };

  // Section CRUD Actions
  const openEditSection = (index) => {
    setEditingIndex(index);
    if (index >= 0) {
      setSectionForm({ ...sections[index] });
    } else {
      setSectionForm({
        title: "",
        type: "video",
        content: "",
        transcript: "",
        isVideoUpload: false});
    }
    onOpen();
  };

  const saveSection = () => {
    if (!sectionForm.title.trim() || !sectionForm.content.trim()) {
      toast({ title: "Please fill all fields", status: "warning", duration: 3000 });
      return;
    }

    const isDuplicate = sections.some((sec, idx) => 
      sec.title.toLowerCase() === sectionForm.title.toLowerCase() && idx !== editingIndex
    );
    if (isDuplicate) {
      toast({ title: "Module with this name already exists in this course", status: "error", duration: 3000 });
      return;
    }

    const updatedForm = { ...sectionForm };
    const contentLower = updatedForm.content.toLowerCase();
    
    // Auto-detect file types based on URL if not already set by upload handler
    if (!updatedForm.isVideoUpload && updatedForm.type !== 'documentation') {
      if (contentLower.endsWith('.pdf') || contentLower.includes('.pdf?') || updatedForm.content.includes('/api/uploads/pdf')) {
        updatedForm.type = 'documentation';
        updatedForm.isVideoUpload = false;
      } else if (updatedForm.content.includes('/api/uploads/') || updatedForm.content.includes('res.cloudinary.com/')) {
        // If it's a Cloudinary link or local upload and not a PDF, assume video upload
        if (!contentLower.endsWith('.jpg') && !contentLower.endsWith('.png')) {
           updatedForm.type = 'video';
           updatedForm.isVideoUpload = true;
        }
      } else if (updatedForm.type === 'video') {
        updatedForm.isVideoUpload = false; // YouTube embed
      }
    }

    const updatedSections = [...sections];
    if (editingIndex >= 0) {
      updatedSections[editingIndex] = updatedForm;
      toast({ title: "Module updated in list", status: "info", duration: 2000 });
    } else {
      updatedSections.push(updatedForm);
      toast({ title: "New module added to list", status: "success", duration: 2000 });
    }

    setSections(updatedSections);
    onClose();
  };

  const deleteSection = async (index) => {
    const _c = await confirm({ title: "Confirm", description: "Are you sure you want to delete this module from the course?", status: "warning" }); 
    if (_c) {
      const updated = sections.filter((_, idx) => idx !== index);
      setSections(updated);
      toast({ title: "Module removed", status: "warning", duration: 2000 });
    }
  };

  const moveUp = (index) => {
    if (index === 0) return;
    const updated = [...sections];
    const temp = updated[index];
    updated[index] = updated[index - 1];
    updated[index - 1] = temp;
    setSections(updated);
  };

  const moveDown = (index) => {
    if (index === sections.length - 1) return;
    const updated = [...sections];
    const temp = updated[index];
    updated[index] = updated[index + 1];
    updated[index + 1] = temp;
    setSections(updated);
  };

  const handleGenerateFinalQuiz = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("user"))?.token;
      toast({ title: "Generating AI Quiz...", description: "Analyzing course material. This may take a minute.", status: "info", duration: 5000 });
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/courses/${id}/generate-full-quiz`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast({ title: "Success", description: "Final quiz generated and appended!", status: "success", duration: 3000 });
      if (res.data && res.data.course && res.data.course.sections) {
        setSections(res.data.course.sections);
      }
    } catch (err) {
      toast({ title: "Failed to generate quiz", description: err.response?.data?.message || err.message, status: "error", duration: 3000 });
    }
  };

  const handleSubmit = () => {
    if (!detail.title.trim()) {
      toast({ title: "Title is required", status: "error", duration: 3000 });
      return;
    }

    const payload = {
      ...detail,
      sections: sections};

    dispatch(patchProduct(id, payload));
    toast({ title: "Course saved successfully!", status: "success", duration: 3000 });
    setTimeout(() => {
      navigate("/admin/courses");
    }, 1000);
  };

  const bgMain = useColorModeValue("var(--background)", "gray.900");
  const textMain = useColorModeValue("gray.800", "gray.100");
  const textSub = useColorModeValue("gray.500", "gray.400");
  const cardBg = useColorModeValue("white", "gray.800");
  const cardBorder = useColorModeValue("gray.200", "gray.700");
  const headerText = useColorModeValue("purple.800", "purple.200");
  const modalBg = useColorModeValue("white", "gray.800");
  const inputBg = useColorModeValue("white", "gray.700");
  const hoverBg = useColorModeValue("purple.50", "whiteAlpha.100");
  const sectionBg = useColorModeValue("gray.50", "gray.700");
  const activeSectionBg = useColorModeValue("purple.50", "purple.900");
  const blueBg1 = useColorModeValue("blue.50", "blue.900");
  const blueBg2 = useColorModeValue("blue.50", "blue.800");

  if (isLoading) {
    return (
      <Flex h="100vh" align="center" justify="center">
        <Spinner size="xl" color="purple.500" thickness="4px" />
      </Flex>
    );
  }

  return (
    <Box minH="100vh" bg={bgMain} pb={10}>
      <AdminNavTop />
      
      <Box maxW="1200px" mx="auto" px={6} pt="100px">
        <Heading size="lg" mb={6} color={headerText} fontWeight="800">
          ⚙️ Edit Corporate Course Settings (Admin Mode)
        </Heading>

        <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={8} alignItems="start">
          {/* Metadata Card */}
          <Card borderRadius="2xl" border="1px solid" borderColor={cardBorder} boxShadow="sm" bg={cardBg}>
            <CardBody p={6}>
              <Heading size="sm" mb={4} color={textMain}>Course Metadata</Heading>
              
              <VStack spacing={4} align="stretch">
                <FormControl isRequired>
                  <FormLabel fontSize="sm" fontWeight="bold">Course Title</FormLabel>
                  <Input
                    type="text"
                    name="title"
                    value={detail.title}
                    onChange={handleChange}
                    placeholder="Enter Course Title"
                  />
                </FormControl>

                <FormControl isRequired>
                  <FormLabel fontSize="sm" fontWeight="bold">Course Description</FormLabel>
                  <Textarea
                    name="description"
                    value={detail.description}
                    onChange={handleChange}
                    placeholder="Enter course details, key learning goals..."
                    rows={4}
                  />
                </FormControl>

                <FormControl isRequired>
                  <FormLabel fontSize="sm" fontWeight="bold">Category</FormLabel>
                  <Select
                    placeholder="Select Course Category"
                    name="category"
                    value={detail.category}
                    onChange={(e) => {
                      if (e.target.value === "custom") {
                        setShowCustomInput(true);
                        setDetail(prev => ({ ...prev, category: "" }));
                      } else {
                        setShowCustomInput(false);
                        handleChange(e);
                      }
                    }}
                  >
                    {categories.map((cat) => (
                      <option key={cat._id} value={cat.name}>{cat.name}</option>
                    ))}
                    <option value="custom">+ Add Custom Category...</option>
                  </Select>

                  {showCustomInput && (
                    <Flex mt={2} gap={2}>
                      <Input
                        placeholder="New Category Name"
                        value={customCategory}
                        onChange={(e) => setCustomCategory(e.target.value)}
                      />
                      <Button colorScheme="green" onClick={handleAddCustomCategory}>Add</Button>
                    </Flex>
                  )}
                </FormControl>

                <FormControl isRequired>
                  <FormLabel fontSize="sm" fontWeight="bold">Department</FormLabel>
                  <Select
                    placeholder="Select Department"
                    name="department"
                    value={detail.department}
                    onChange={handleChange}
                  >
                    {DEPARTMENTS.map((dept) => (
                      <option key={dept} value={dept}>{dept}</option>
                    ))}
                  </Select>
                </FormControl>

                <FormControl isRequired>
                  <FormLabel fontSize="sm" fontWeight="bold">Instructor</FormLabel>
                  <Select
                    placeholder="Select Instructor"
                    name="teacherId"
                    value={detail.teacherId || ""}
                    onChange={(e) => {
                      const selected = teachers.find(t => t._id === e.target.value);
                      setDetail(prev => ({
                        ...prev,
                        teacherId: e.target.value,
                        teacher: selected ? selected.fullName : ""
                      }));
                    }}
                  >
                    {teachers.map((t) => (
                      <option key={t._id} value={t._id}>{t.fullName} ({t.email})</option>
                    ))}
                  </Select>
                </FormControl>

                <FormControl display="flex" alignItems="center">
                  <FormLabel mb="0" fontSize="sm" fontWeight="bold">Enable Discussion & Comments?</FormLabel>
                  <Switch
                    isChecked={detail.allowComments}
                    onChange={(e) => setDetail(prev => ({ ...prev, allowComments: e.target.checked }))}
                    colorScheme="purple"
                  />
                </FormControl>

                <FormControl display="flex" alignItems="center">
                  <FormLabel mb="0" fontSize="sm" fontWeight="bold">Global Training Module (Available to all departments)?</FormLabel>
                  <Switch
                    isChecked={detail.isGlobal}
                    onChange={(e) => setDetail(prev => ({ ...prev, isGlobal: e.target.checked }))}
                  />
                </FormControl>

                {!detail.isGlobal && (
                  <FormControl>
                    <FormLabel fontSize="sm" fontWeight="bold">Select Target Departments / Sectors</FormLabel>
                    <CheckboxGroup
                      colorScheme="purple"
                      value={detail.targetSectors}
                      onChange={(values) => setDetail(prev => ({ ...prev, targetSectors: values }))}
                    >
                      <Stack spacing={2} direction="row" wrap="wrap">
                        {DEPARTMENTS.map((dept) => (
                          <Checkbox key={dept} value={dept}>{dept}</Checkbox>
                        ))}
                      </Stack>
                    </CheckboxGroup>
                  </FormControl>
                )}

                <FormControl isRequired>
                  <FormLabel fontSize="sm" fontWeight="bold">Course Thumbnail Image URL</FormLabel>
                  <Input
                    type="text"
                    name="img"
                    value={detail.img}
                    onChange={handleChange}
                    placeholder="Paste image URL here"
                  />
                </FormControl>
              </VStack>
            </CardBody>
          </Card>

          {/* Curriculum Card */}
          <Card borderRadius="2xl" border="1px solid" borderColor={cardBorder} boxShadow="sm" bg={cardBg}>
            <CardBody p={6}>
              <Flex justify="space-between" align="center" mb={4}>
                <Box>
                  <Heading size="sm" color={textMain}>Curriculum & Modules</Heading>
                  <Text fontSize="xs" color={textSub} mt={1}>Reorder, replace, or delete lesson materials</Text>
                </Box>
                <HStack spacing={2}>
                  <Button 
                    size="sm" 
                    colorScheme="teal" 
                    variant="outline"
                    borderRadius="full"
                    onClick={handleGenerateFinalQuiz}
                  >
                    ✨ Generate AI Quiz
                  </Button>
                  <Button 
                    size="sm" 
                    colorScheme="purple" 
                    leftIcon={<AddIcon />} 
                    borderRadius="full"
                    onClick={() => openEditSection(-1)}
                  >
                    Add Module
                  </Button>
                </HStack>
              </Flex>

              {sections.length === 0 ? (
                <Box py={10} textAlign="center" border="2px dashed" borderColor={cardBorder} borderRadius="xl">
                  <Text color={textSub} fontSize="sm" fontWeight="semibold">No videos or PDF files uploaded yet.</Text>
                  <Button size="xs" mt={2} colorScheme="purple" onClick={() => openEditSection(-1)}>
                    Upload First File
                  </Button>
                </Box>
              ) : (
                <Box overflowX="auto">
                  <Table size="sm" variant="simple">
                    <Thead>
                      <Tr>
                        <Th width="70px">Order</Th>
                        <Th>Title</Th>
                        <Th>Type</Th>
                        <Th textAlign="right">Actions</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {sections.map((sec, idx) => (
                        <Tr key={idx} _hover={{ bg: hoverBg }} transition="background 0.2s">
                          <Td>
                            <HStack spacing={1}>
                              <IconButton
                                size="xs"
                                icon={<ArrowUpIcon />}
                                isDisabled={idx === 0}
                                onClick={() => moveUp(idx)}
                                aria-label="Move Up"
                              />
                              <IconButton
                                size="xs"
                                icon={<ArrowDownIcon />}
                                isDisabled={idx === sections.length - 1}
                                onClick={() => moveDown(idx)}
                                aria-label="Move Down"
                              />
                            </HStack>
                          </Td>
                          <Td fontWeight="bold" maxW="200px" isTruncated>
                            {sec.title}
                          </Td>
                          <Td>
                            <Badge colorScheme={sec.type === "video" ? "blue" : sec.type === "quiz" ? "purple" : "orange"} borderRadius="full" fontSize="10px">
                              {sec.type === "video" ? (sec.isVideoUpload ? "📤 Uploaded" : "🔗 YouTube") : sec.type === "quiz" ? "📝 Quiz" : "📄 PDF"}
                            </Badge>
                          </Td>
                          <Td textAlign="right">
                            <HStack spacing={1} justify="flex-end">
                              <IconButton
                                size="xs"
                                colorScheme="blue"
                                icon={<EditIcon />}
                                onClick={() => openEditSection(idx)}
                                aria-label="Edit/Replace Section"
                              />
                              <IconButton
                                size="xs"
                                colorScheme="red"
                                icon={<DeleteIcon />}
                                onClick={() => deleteSection(idx)}
                                aria-label="Delete Section"
                              />
                            </HStack>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </Box>
              )}
            </CardBody>
          </Card>
        </Grid>

        <Button
          mt={8}
          colorScheme="purple"
          size="lg"
          w="full"
          borderRadius="xl"
          onClick={handleSubmit}
          boxShadow="lg"
          fontWeight="bold"
        >
          Save All Changes
        </Button>
      </Box>

      {/* Edit Section Modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="xl" motionPreset="slideInBottom">
        <ModalOverlay backdropFilter="blur(10px)" bg="blackAlpha.300" />
        <ModalContent borderRadius="3xl" overflow="hidden" boxShadow="2xl" border="1px solid" borderColor={cardBorder} bg={modalBg} color={textMain}>
          <ModalHeader 
            bgGradient="linear(to-r, purple.600, blue.500)" 
            color="white" 
            pb={6}
            boxShadow="sm"
          >
            <Flex align="center" gap={3}>
              <Icon as={editingIndex >= 0 ? EditIcon : AddIcon} w={5} h={5} />
              <Text>{editingIndex >= 0 ? "📝 Replace / Edit Lesson Module" : "📤 Add Content Module"}</Text>
            </Flex>
          </ModalHeader>
          <ModalCloseButton color="white" mt={1} />
          
          <ModalBody pt={6} pb={8} px={8}>
            <VStack spacing={6} align="stretch">
              <FormControl isRequired>
                <FormLabel fontSize="sm" fontWeight="bold" color={textMain}>Module Title</FormLabel>
                <Input
                  type="text"
                  name="title"
                  size="lg"
                  borderRadius="xl"
                  value={sectionForm.title}
                  onChange={handleSectionFormChange}
                  placeholder="e.g. Introduction to Financial modeling"
                  _focus={{ borderColor: "purple.500", boxShadow: "0 0 0 1px purple.500" }}
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel fontSize="sm" fontWeight="bold" color={textMain}>Select Module Type</FormLabel>
                <Grid templateColumns="repeat(3, 1fr)" gap={4}>
                  <Box 
                    as="button" p={4} borderRadius="xl" border="2px solid" 
                    borderColor={sectionForm.type === 'video' ? 'purple.500' : cardBorder} 
                    bg={sectionForm.type === 'video' ? activeSectionBg : inputBg}
                    _hover={{ borderColor: 'purple.300', bg: hoverBg, transform: 'translateY(-2px)' }}
                    transition="all 0.2s"
                    onClick={() => setSectionForm(prev => ({ ...prev, type: 'video', isVideoUpload: false, content: "", transcript: "" }))}
                  >
                    <VStack spacing={2}>
                      <Icon as={FaPlayCircle} w={6} h={6} color={sectionForm.type === 'video' ? 'purple.600' : textSub} />
                      <Text fontSize="sm" fontWeight="bold" color={sectionForm.type === 'video' ? headerText : textSub}>Video Lesson</Text>
                    </VStack>
                  </Box>
                  <Box 
                    as="button" p={4} borderRadius="xl" border="2px solid" 
                    borderColor={sectionForm.type === 'documentation' ? 'purple.500' : cardBorder} 
                    bg={sectionForm.type === 'documentation' ? activeSectionBg : inputBg}
                    _hover={{ borderColor: 'purple.300', bg: hoverBg, transform: 'translateY(-2px)' }}
                    transition="all 0.2s"
                    onClick={() => setSectionForm(prev => ({ ...prev, type: 'documentation', isVideoUpload: false, content: "", transcript: "" }))}
                  >
                    <VStack spacing={2}>
                      <Icon as={FaFilePdf} w={6} h={6} color={sectionForm.type === 'documentation' ? 'purple.600' : textSub} />
                      <Text fontSize="sm" fontWeight="bold" color={sectionForm.type === 'documentation' ? headerText : textSub}>PDF Document</Text>
                    </VStack>
                  </Box>
                  <Box 
                    as="button" p={4} borderRadius="xl" border="2px solid" 
                    borderColor={sectionForm.type === 'quiz' ? 'purple.500' : cardBorder} 
                    bg={sectionForm.type === 'quiz' ? activeSectionBg : inputBg}
                    _hover={{ borderColor: 'purple.300', bg: hoverBg, transform: 'translateY(-2px)' }}
                    transition="all 0.2s"
                    onClick={() => setSectionForm(prev => ({ ...prev, type: 'quiz', isVideoUpload: false, content: "", transcript: "" }))}
                  >
                    <VStack spacing={2}>
                      <Icon as={FaBrain} w={6} h={6} color={sectionForm.type === 'quiz' ? 'purple.600' : textSub} />
                      <Text fontSize="sm" fontWeight="bold" color={sectionForm.type === 'quiz' ? headerText : textSub}>AI Quiz</Text>
                    </VStack>
                  </Box>
                </Grid>
              </FormControl>

              {sectionForm.type === "video" && (
                <Box p={5} bg={sectionBg} borderRadius="2xl" border="1px dashed" borderColor={cardBorder}>
                  <FormControl isRequired mb={4}>
                    <FormLabel fontSize="sm" fontWeight="bold" color={textMain}>Video Source</FormLabel>
                    <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                      <Box 
                        as="button" p={3} borderRadius="lg" border="2px solid" 
                        borderColor={!sectionForm.isVideoUpload ? 'blue.400' : cardBorder} 
                        bg={!sectionForm.isVideoUpload ? blueBg1 : inputBg}
                        _hover={{ borderColor: 'blue.300', bg: blueBg2 }}
                        transition="all 0.2s"
                        onClick={() => setSectionForm(prev => ({ ...prev, isVideoUpload: false, content: "", transcript: "" }))}
                      >
                        <Text fontSize="sm" fontWeight="bold" color={!sectionForm.isVideoUpload ? 'blue.400' : textSub}>🔗 YouTube URL</Text>
                      </Box>
                      <Box 
                        as="button" p={3} borderRadius="lg" border="2px solid" 
                        borderColor={sectionForm.isVideoUpload ? 'blue.400' : cardBorder} 
                        bg={sectionForm.isVideoUpload ? blueBg1 : inputBg}
                        _hover={{ borderColor: 'blue.300', bg: blueBg2 }}
                        transition="all 0.2s"
                        onClick={() => setSectionForm(prev => ({ ...prev, isVideoUpload: true, content: "", transcript: "" }))}
                      >
                        <Text fontSize="sm" fontWeight="bold" color={sectionForm.isVideoUpload ? 'blue.400' : textSub}>📤 Upload File</Text>
                      </Box>
                    </Grid>
                  </FormControl>

                  {sectionForm.isVideoUpload ? (
                    <Box>
                      <FormControl isRequired>
                        <FormLabel fontSize="sm" fontWeight="bold">Upload Video File</FormLabel>
                        <HStack>
                          <Input
                            value={sectionForm.content}
                            placeholder="Upload path will appear here"
                            readOnly
                          />
                          <Box position="relative">
                            <Button colorScheme="purple" variant="solid" isLoading={isUploading}>
                              Browse
                            </Button>
                            <Input
                              type="file"
                              accept="video/*"
                              position="absolute"
                              top={0}
                              left={0}
                              w="full"
                              h="full"
                              opacity={0}
                              cursor="pointer"
                              onChange={handleFileUpload}
                              disabled={isUploading}
                            />
                          </Box>
                        </HStack>
                      </FormControl>
                      {isUploading && (
                        <HStack spacing={2} mt={2}>
                          <Spinner size="xs" color="purple.500" />
                          <Text fontSize="xs" color="purple.500" fontWeight="bold">AI is uploading & transcribing (OpenAI Whisper)...</Text>
                        </HStack>
                      )}
                    </Box>
                  ) : (
                    <FormControl isRequired>
                      <FormLabel fontSize="sm" fontWeight="bold">YouTube Video URL</FormLabel>
                      <Input
                        type="text"
                        name="content"
                        value={sectionForm.content}
                        onChange={handleSectionFormChange}
                        placeholder="Paste YouTube video link"
                      />
                    </FormControl>
                  )}

                  <FormControl mt={4}>
                    <FormLabel fontSize="sm" fontWeight="bold" color={textMain}>Video Transcript (Optional)</FormLabel>
                    <Textarea
                      name="transcript"
                      value={sectionForm.transcript}
                      onChange={handleSectionFormChange}
                      placeholder="Autogenerated transcript or custom text..."
                      rows={3}
                      _focus={{ borderColor: "purple.500", boxShadow: "0 0 0 1px purple.500" }}
                    />
                  </FormControl>
                </Box>
              )}

              {sectionForm.type === "documentation" && (
                <Box p={5} bg={sectionBg} borderRadius="2xl" border="1px dashed" borderColor={cardBorder}>
                  <FormControl isRequired>
                    <FormLabel fontSize="sm" fontWeight="bold" color={textMain}>PDF Source Link</FormLabel>
                    <HStack>
                      <Input
                        type="text"
                        name="content"
                        value={sectionForm.content}
                        onChange={handleSectionFormChange}
                        placeholder="Paste PDF link or upload a file"
                        _focus={{ borderColor: "purple.500", boxShadow: "0 0 0 1px purple.500" }}
                      />
                      <Box position="relative">
                        <Button colorScheme="purple" variant="outline" isLoading={isUploading}>
                          Upload PDF
                        </Button>
                        <Input
                          type="file"
                          accept=".pdf"
                          position="absolute"
                          top={0}
                          left={0}
                          w="full"
                          h="full"
                          opacity={0}
                          cursor="pointer"
                          onChange={handleFileUpload}
                          disabled={isUploading}
                        />
                      </Box>
                    </HStack>
                  </FormControl>
                  {isUploading && (
                    <HStack spacing={2} mt={3}>
                      <Spinner size="xs" color="purple.500" />
                      <Text fontSize="xs" color="purple.500" fontWeight="bold">Uploading PDF document...</Text>
                    </HStack>
                  )}
                </Box>
              )}

              {sectionForm.type === "quiz" && (
                <Box p={5} bg="purple.50" borderRadius="2xl" border="1px solid" borderColor="purple.200" textAlign="center">
                  <Icon as={FaBrain} w={10} h={10} color="purple.500" mb={3} />
                  <Heading size="sm" color="purple.800" mb={2} className="dark-text-black">AI Quiz Generation Ready</Heading>
                  <Text color="purple.600" fontSize="sm" className="dark-text-black">
                    Once you save this module, AI will automatically read your previous lessons and generate a comprehensive quiz here.
                  </Text>
                </Box>
              )}
            </VStack>
          </ModalBody>

          <ModalFooter bg="gray.50" borderTop="1px solid" borderColor="gray.100">
            <Button variant="ghost" mr={3} onClick={onClose} borderRadius="xl">
              Cancel
            </Button>
            <Button colorScheme="purple" onClick={saveSection} isDisabled={isUploading} borderRadius="xl" size="lg" px={8} boxShadow="md">
              Save Module
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default EditPage;
